<script lang="ts" setup>
import { Ref } from 'vue'

withDefaults(
  defineProps<{
    title: string
    index: number
  }>(),
  {},
)

const activeIndex = inject('activeIndex') as Ref<number>

const open = (index: number) => {
  activeIndex.value = index
}
</script>

<template>
  <li :index="index" :is-active="index === activeIndex" class="tab-header" @click="open(index)">
    <button class="label">{{ title }}</button>
  </li>
</template>

<style lang="scss" scoped>
.tab-header {
  &[is-active='true'],
  &:hover {
    button {
      opacity: 1;
      border-bottom-color: var(--c-primary);
    }
  }

  button {
    color: var(--c-primary);

    padding-block: 30px;
    border-bottom: 2px solid transparent;

    opacity: 0.5;

    @include transitions(opacity, border-bottom-color);
  }
}
</style>
